import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarCatalogosGenericoAsync} from '../../funciones_globales/catalogos';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import {desformatearFecha} from '../../funciones_globales/format'
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';

class FormCli16 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            cliente_sel: null,
            vendedor_sel: null
        }
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.imprimirReporteNCfavor = this.imprimirReporteNCfavor.bind(this);

    }


    limpiar(){
   
        this.setState({
            cliente_sel: null,
            vendedor_sel: null,
        }) 
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    imprimirReporteNCfavor(){
        try{
            let fechaProceso = getFechaProcesoPorModulo('01');  
            let urlReportWithParams = '';
            urlReportWithParams=`&rpt=100`;

            urlReportWithParams+=`&param1=${desformatearFecha(fechaProceso)}`;

            if(this.state.cliente_sel){
                urlReportWithParams+=`&param2=${this.state.cliente_sel.value}`;
            }
            if(this.state.vendedor_sel){
                urlReportWithParams+=`&param3=${this.state.vendedor_sel.value}`;
            }
            visualizarReporteEnPdf(urlReportWithParams);
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0116').then(()=>{
            this.setState({permiso: this.props.permiso})
        })
        .catch((error)=>{

        })
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0116');
    }

    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }


    render(){
        return(
            <ContenedorForm porc_ancho={60}>
             <HeaderForm>
                <TituloForm>Nota de Credito a Favor de Clientes Pendientes</TituloForm>
            </HeaderForm>
                <CuerpoForm>

                        
                            <Row margen_arriba={10}>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Vendedor:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-6'>
                                    <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} 
                                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({vendedor_sel: value});}}/>
                                </ContainerCol>
                            </Row>
                            <Row margen_arriba={10}>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Cliente:</LabelForm>
                                </ContainerCol>
                                <ContainerCol className='col-sm-6'>
                                    <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                                    func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({cliente_sel: value});}}/>
                                </ContainerCol>
                        </Row> 
                                       
                    <Row margen_arriba={20}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirReporteNCfavor}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>

                </CuerpoForm>
            </ContenedorForm>
        )
    }

}


const mapStateToProps = ((state) => {
    return {permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            departamento : state.sesion.valoresSesionForm.Departamento
        }
  });
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
        cambiar_VisualizacionLoading }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCli16);
